import { resourcePath } from '../potreeState';

/** Declare jQuery as global */
declare const $: (selector: string) => JQueryLike;

/** Minimal jQuery-like interface for Message DOM usage */
interface JQueryLike {
  find(selector: string): JQueryLike;
  append(content: JQueryLike | string): JQueryLike;
  empty(): JQueryLike;
  click(handler: () => void): JQueryLike;
  css(property: string, value: string): JQueryLike;
  slideToggle(duration: number): JQueryLike;
  animate(properties: Record<string, unknown>, duration: number): JQueryLike;
  prepend(content: JQueryLike | string): JQueryLike;
  addClass(className: string): JQueryLike;
}

export class Message {
  content: string | JQueryLike;
  element: JQueryLike;
  elClose: JQueryLike;
  elContainer: JQueryLike;

  constructor(content: string | JQueryLike) {
    this.content = content;

    const closeIcon = `${resourcePath}/icons/close.svg`;

    this.element = $(`
			<div class="potree_message">
				<span name="content_container" style="flex-grow: 1; padding: 5px"></span>
				<img name="close" src="${closeIcon}" class="button-icon" style="width: 16px; height: 16px;">
			</div>`);

    this.elClose = this.element.find('img[name=close]');

    this.elContainer = this.element.find('span[name=content_container]');

    if (typeof content === 'string') {
      this.elContainer.append($(`<span>${content}</span>`));
    } else {
      this.elContainer.append(content);
    }
  }

  setMessage(content: string | JQueryLike) {
    this.elContainer.empty();
    if (typeof content === 'string') {
      this.elContainer.append($(`<span>${content}</span>`));
    } else {
      this.elContainer.append(content);
    }
  }
}
